import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SitePage } from '@training/models/site-page.model';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebProxyService {
  constructor(private http: HttpClient) { }

  async getSitePagesAsync(
    webProyUri: string,
    webProxyEndPoint: string,
    documentId: string,
    sharepointId: string,
    documentVersion: string
  ): Promise<SitePage[]> {
    let sitePages: SitePage[] = null;
    let subscription: Subscription;
    const promise = new Promise<void>((resolve, reject) => {
      subscription = this.http
        .get<SitePage[]>(
          `${webProyUri}/${webProxyEndPoint}/sites/${documentId}/${sharepointId}/${documentVersion}/pages.json`,
          {
            withCredentials: true
          }
        )
        .subscribe(
          (x) => {
            sitePages = x.map((p) => {
              p.url = `${webProyUri}/${webProxyEndPoint}/sites/${documentId}/${sharepointId}/${documentVersion}/${p.url}`;
              return p;
            });
            resolve();
          },
          (error) => {
            reject(error);
          }
        );
    });
    await promise.catch((error) => console.error(error));
    subscription.unsubscribe();
    return sitePages;
  }

  async signInToProxyAsync(
    webProyUri: string,
    authenticationEndPoint: string
  ): Promise<boolean> {
    let subscription: Subscription;
    let isSignedIn = false;
    const promise = new Promise<void>((resolve, reject) => {
      subscription = this.http
        .get(`${webProyUri}/${authenticationEndPoint}`, {
          observe: 'response',
          withCredentials: true
        })
        .subscribe(
          (x: HttpResponse<object>) => {
            if (x.ok) {
              isSignedIn = true;
            }
            resolve();
          },
          (error) => {
            reject(error);
          }
        );
    });
    await promise.catch((error) => console.error(error));
    subscription.unsubscribe();
    return isSignedIn;
  }
}
